module.exports = __webpack_public_path__ + "img/guanfang.d5f0762e.png";